import { Collapse, Offcanvas } from 'bootstrap'

function handleOffcanvasEvents() {
  const offcanvasOffsetElement = document.querySelector('.navigation-bar-mobile')
  const offcanvasButton = document.getElementById('headerOffcanvasButton')
  const offcanvas = document.getElementById('headerOffcanvas')

  if (offcanvasOffsetElement && offcanvasButton && offcanvas) {
    offcanvas.addEventListener('show.bs.offcanvas', event => {
      offcanvasButton.classList.add('offcanvas-open')
      let topOffset = offcanvasOffsetElement.getBoundingClientRect().bottom
      offcanvas.style.top = `${topOffset}px`
    })

    offcanvas.addEventListener('hide.bs.offcanvas', event => {
      offcanvasButton.classList.remove('offcanvas-open')
    })
  }
}

function handleMainNavigationEvents() {
  const mainNavigationCollapses = document.querySelectorAll('.navigation-menu-dropdowns .collapse')
  const mainNavigationItemsContainer = document.querySelectorAll('.main-navigation-items')
  let collapseOpenCount = 0

  if (mainNavigationCollapses && mainNavigationItemsContainer) {
    mainNavigationCollapses.forEach(collapse => {
      collapse.addEventListener('hide.bs.collapse', event => {
        collapseOpenCount--;
        if (collapseOpenCount <= 0) {
          mainNavigationItemsContainer.forEach(container => container.classList.remove('dropdown-open'))
        }
      })
      collapse.addEventListener('show.bs.collapse', event => {
        collapseOpenCount++;
        if (collapseOpenCount > 0) {
          mainNavigationItemsContainer.forEach(container => container.classList.add('dropdown-open'))
        }
      })
    })
  }
}

function handleHeaderScrollEvents() {
  const navigationBar = document.querySelector('.navigation-bar')
  const mainNavigationSmallLogoLink = document.querySelector('.main-navigation-small-logo-link')
  
  if (navigationBar && mainNavigationSmallLogoLink) {
    let offscreenObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            mainNavigationSmallLogoLink?.classList.remove('show')
          } else {
            mainNavigationSmallLogoLink?.classList.add('show')
          }
        } )
      },
      { root: null, rootMargin: '0px', threshold: 0 }
    )
  
    offscreenObserver.observe(navigationBar)
  }
}

function handleKeyboardAndMouseEvents() {
  // On escape keypress, collapse all header collapses
  const headerCollapses = document.querySelectorAll('header .collapse, .main-navigation-wrapper .collapse')
  if (headerCollapses) {
    document.addEventListener('keydown', (event) => {
      if (event?.key === 'Escape' || event?.key === 'Esc') {
        headerCollapses.forEach((headerCollapse) => {
          const collapse = Collapse.getOrCreateInstance(headerCollapse, { toggle: false })
          collapse.hide()
        })
      }
    })
  }
  
  // On click outside main navigation, close all main navigation collapses
  const mainNavigationWrapper = document.querySelector('.main-navigation-wrapper')
  const mainNavigationCollapses = document.querySelectorAll('.main-navigation-wrapper .collapse')
  if (mainNavigationWrapper && mainNavigationCollapses) {
    document.addEventListener('click', (event) => {
      if (!mainNavigationWrapper.contains(event.target)) {
        mainNavigationCollapses.forEach((mainNavigationCollapse) => {
          const collapse = Collapse.getOrCreateInstance(mainNavigationCollapse, { toggle: false })
          collapse.hide()
        })
      }
    })
  }

  // On click outside header and main navigation, close header offcanvas and search collapse
  const header = document.querySelector('header')
  const headerOffcanvas = document.querySelector('#headerOffcanvas')
  const navigationSearchCollapse = document.querySelector('#navigationMobileSearchCollapse')
  if (header && headerOffcanvas && navigationSearchCollapse) {
    document.addEventListener('click', (event) => {
      if (!header.contains(event.target) && !mainNavigationWrapper.contains(event.target)) {
        const offcanvasInstance = Offcanvas.getOrCreateInstance(headerOffcanvas, { toggle: false})
        offcanvasInstance.hide()
        const collapseInstance = Collapse.getOrCreateInstance(navigationSearchCollapse, { toggle: false})
        collapseInstance.hide()
      }
    })
  }
}

function handleSearchToggleEvents() {
  const navigationSearchInput = document.querySelector('#navigationMobileSearchInput')
  const navigationSearchCollapse = document.querySelector('#navigationMobileSearchCollapse')
  const headerOffcanvas = document.querySelector('#headerOffcanvas')
  
  if (navigationSearchInput && navigationSearchCollapse && headerOffcanvas) {

    // When search collapse is expanded, close header offcanvas
    navigationSearchCollapse.addEventListener('show.bs.collapse', event => {
      const offcanvasInstance = Offcanvas.getOrCreateInstance(headerOffcanvas, { toggle: false})
      offcanvasInstance.hide()
    })

    // When search collapse is done showing, focus on the search input
    navigationSearchCollapse.addEventListener('shown.bs.collapse', event => {
      navigationSearchInput.focus()
    })

    // When offcanvas is expanded, close search collapse
    headerOffcanvas.addEventListener('show.bs.offcanvas', event => {
      const collapseInstance = Collapse.getOrCreateInstance(navigationSearchCollapse, { toggle: false})
      collapseInstance.hide()
    })
  }
}
function handleMobileClickEvents() {
  let elements = document.querySelectorAll('.nav-link.collapsed')

  elements.forEach(elem => {
    let collapseItem = elem.nextElementSibling.children[0]

    if (collapseItem.getAttribute('data-bs-parent') === '#mainNavigationMobile') {

      collapseItem.addEventListener('shown.bs.collapse', event => {
        collapseItem.scrollIntoView({ behavior: 'smooth' });
      })

    }
  })
}


document.addEventListener('DOMContentLoaded', (event) => {
  handleOffcanvasEvents()
  handleMainNavigationEvents()
  handleHeaderScrollEvents()
  handleKeyboardAndMouseEvents()
  handleSearchToggleEvents()
  handleMobileClickEvents()
});
